import React, { Component } from 'react';
import MachineDiagramListView from '../views/MachineDiagramListView';
import { base } from '../../base';

class MachineDiagramListContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            diagrams: [],
        };
    }

    componentWillMount() {
        this.valuesRef = base.syncState(`diagrams/${this.props.extraUser.companyid}`, {
            context: this,
            asArray: true,
            state: 'diagrams',
            queries: {
                orderByChild: 'machineid',
                equalTo: this.props.machineId,
            },
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.valuesRef);
    }

    render() {
        console.log(this.state.quotations);
        return (
            <MachineDiagramListView
                diagrams={this.state.diagrams}
            />
        );
    }
}

export default MachineDiagramListContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineDiagramListContainer.js